import { Record } from "immutable";

const DistributionRecord = Record({
  bubbleChart: {},
  commentId: null,
  comment: "",
  initComment: ""
});

class Distribution extends DistributionRecord {}

export default Distribution;



// WEBPACK FOOTER //
// ./src/models/Distribution.js